import { render, staticRenderFns } from "./PromoEscalated.vue?vue&type=template&id=6892116d&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6892116d')) {
      api.createRecord('6892116d', component.options)
    } else {
      api.reload('6892116d', component.options)
    }
    module.hot.accept("./PromoEscalated.vue?vue&type=template&id=6892116d&", function () {
      api.rerender('6892116d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Promo/view/PromoEscalated.vue"
export default component.exports